export const selectBookDetails = state => state.bookDetails;
